(() => {
    document.addEventListener("DOMContentLoaded", function () {
        const container = document.querySelector(".js-no-wrap");
        if (!container) return;

        // Function to check if the container is overflowing
        const checkOverflow = () => {
            if (container.scrollWidth > container.clientWidth) {
                container.classList.add("overflowing");
            } else {
                container.classList.remove("overflowing");
            }
        };

        // Initial check on page load
        checkOverflow();

        // Re-check if window is resized
        window.addEventListener("resize", checkOverflow);

        let isDown = false;
        let startX;
        let scrollLeft;

        // Only add event listeners for drag if overflowing
        const enableDrag = () => {
            container.addEventListener("mousedown", (e) => {
                isDown = true;
                container.classList.add("active");
                startX = e.pageX - container.offsetLeft;
                scrollLeft = container.scrollLeft;
            });

            document.addEventListener("mouseup", () => {
                isDown = false;
                container.classList.remove("active");
            });

            container.addEventListener("mouseleave", () => {
                isDown = false;
                container.classList.remove("active");
            });

            container.addEventListener("mousemove", (e) => {
                if (!isDown) return;
                e.preventDefault();
                const x = e.pageX - container.offsetLeft;
                const walk = (x - startX) * 2; // Adjust speed

                // Calculate the maximum scroll position
                const maxScrollLeft = container.scrollWidth - container.clientWidth;

                // Ensure the scroll position doesn't go beyond the max scroll
                container.scrollLeft = Math.max(0, Math.min(scrollLeft - walk, maxScrollLeft));
            });
        };

        // Enable drag only when overflowing
        if (container.scrollWidth > container.clientWidth) {
            enableDrag();
        }

        // Re-enable drag if the container becomes overflowing after resize
        window.addEventListener("resize", () => {
            if (container.scrollWidth > container.clientWidth) {
                enableDrag();
            }
        });
    });
})();
